module.exports = __webpack_public_path__ + "static/img_9420-7c057a82602f5d51673d4f161d81ad06.webp";